
import "../../assets/stylesheets/realestate.css";
import React, {useContext, useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {Link, useLocation} from "react-router-dom";
import {Helmet} from "react-helmet";
import Logo from "../../assets/image/logo.svg";
import FilterPane from "./FilterPane";
import EstateList from "./EstateList";
import {ContactInfoContext} from "../additional/ContactInfoContext";

function Rent() {
    const location = useLocation();
    const { t, i18n } = useTranslation(["home", "estate"]);
    const { contactInfo } = useContext(ContactInfoContext);

    // Parse query parameters synchronously
    const initialFilter = useMemo(() => {
        const queryParams = new URLSearchParams(location.search);
        const newFilter = new Map();
        queryParams.forEach((value, key) => {
            newFilter.set(key, value.split(",").map(item => item.trim()));
        });
        console.log("Rent: Parsed initial filter:", [...newFilter.entries()]);
        return newFilter;
    }, [location.search]);

    const [filter, setFilter] = useState(initialFilter);

    return (
        <>
            <Helmet>
                <meta name="description" content={t("rentDescribe")}/>
                <link rel="canonical" href={`https://sievn.am/${i18n.language}/${t("estate:rent-url")}`}/>
                <title>{t("rentTitle")}</title>
                <meta property="og:title" content={t("rentTitle")}/>
                <meta property="og:site_name" content="sievn.am"/>
                <meta property="og:url" content={`https://sievn.am/${i18n.language}/${t("estate:rent-url")}`}/>
                <meta property="og:description" content={t("rentDescribe")}/>
                <meta property="og:image" content={Logo}/>
                <meta property="og:image:width" content="1200"/>
                <meta property="og:image:height" content="630"/>
            </Helmet>

            <section className="homepage">
                <div className="home__hero">
                    <img src={contactInfo.homeUrl} alt="Hero background" className="home__hero-image" />
                    <div className="home__hero-overlay">
                        <div className="home__hero-content">
                            <h1 className="home__hero-text2">{t("company-name")}</h1>
                            <h2 className="home__hero-text3">{t("comfort-text")}</h2>
                        </div>
                    </div>
                </div>
                <div className="realestate">
                    <div className="breadcrumb">
                        <Link to={`/${i18n.language}`}>{t("home")}</Link> {"> "}
                        <span>{t("estate:rent-title")}</span>
                    </div>
                </div>
                <div className="realestate__container">
                    <div className="filter__pane">
                        <FilterPane
                            type="rent"
                            language={i18n.language}
                            onFilterChange={(newFilter) => {
                                console.log("Rent: FilterPane onFilterChange:", [...newFilter.entries()]);
                                setFilter(new Map(newFilter));
                            }}
                            initialFilter={filter}
                        />
                    </div>
                    <div className="estate__list">
                        <EstateList type="rent" language={i18n.language} filter={filter} />
                    </div>
                </div>
            </section>
        </>
    );
}

export default Rent;